import * as yup from 'yup';

import './fixMessages';
import {
  validateWhitelabelInfo,
  validateWhitelabelBase,
} from './whitelabel';

const validateWhitelabelBaseSchema = yup
  .object()
  .concat(validateWhitelabelBase)
  .concat(validateWhitelabelInfo);

/** Default whitelabel validation (settings JSON shape only, no privacy-policy rules). */
export default validateWhitelabelBaseSchema;
